export const stepsConstants = {
  i_am_voluntary_insured: 'Ich bin freiwillig versichert.',
  i_do_something_else: 'Ich mache etwas anderes.',
  i_am_employed: 'Ich bin angestellt.',
  please_fill_field_correctly: 'Bitte füllen Sie dieses Feld korrekt aus.',
  please_fill_radio_group: 'Bitte wählen Sie eine der Optionen aus.'
}

export const steps = [
  {
    id: 'step-1',
    name: 'Name',
    title: 'Hallo 👋',
    description: 'Erzählen Sie uns doch kurz, wer Sie sind.',
    formComponent: 'FormName',
    formData: {
      gender: '',
      firstname: '',
      lastname: '',
      salutation: '',
      birthday: null
    },
    formLabels: {
      gender: 'Geschlecht',
      firstname: 'Vorname',
      lastname: 'Nachname',
      salutation: 'Titel',
      birthday: 'Geburtsdatum'
    },
    formOptions: {
      gender: [
        'Frau',
        'Mann',
        'Divers'
      ],
      salutation: [
        'Dr.',
        'Dipl.-Ing.',
        'Dr. med.',
        'Dr. rer. nat.',
        'Dr. Ing.',
        'Prof. Dr.',
        'Dr. phil.',
        'Dipl.-Ing. (FH)',
        'Dr. med. dent.',
        'Dipl.-Kaufmann',
        'Dr. jur.',
        'Dr. med. vet.',
        'Dr. rer. pol.',
        'Dipl.-Wirt.Ing',
        'Dipl.-Betriebswirt'
      ]
    },
    visible: false,
    controls: {
      previous: null,
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-2'
      }
    ]
  },
  {
    id: 'step-2',
    name: 'Address',
    title: 'Wo wohnen Sie zur Zeit? 🏡 🏣 🏬',
    description: '',
    formComponent: 'FormAddress',
    formData: {
      street: '',
      streetNumber: '',
      addressAddition: '',
      zip: '',
      city: '',
      country: 'Deutschland',
      _zipCity: ''
    },
    formLabels: {
      street: 'Straße',
      streetNumber: 'Hausnummer',
      addressAddition: 'Adresszusatz',
      zip: 'PLZ',
      city: 'Stadt',
      country: 'Land',
      _zipCity: 'PLZ/Stadt'
    },
    formOptions: {
      country: window.quickomeCountries ? window.quickomeCountries : []
    },
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-3'
      }
    ]
  },
  {
    id: 'step-3',
    formComponent: 'FormContact',
    name: 'Contact',
    title: 'Wie können wir Sie am besten erreichen? ☎️ ✉️',
    description: 'Sie möchten immer auf dem aktuellen Stand bezüglich Ihrer Mitgliedschaft und dem Bearbeitungsstand sein? Dann hinterlassen Sie uns einfach Ihre Kontaktdaten. Die Angaben sind freiwillig.',
    formData: {
      email: '',
      mobileNumber: ''
    },
    formLabels: {
      email: 'E-Mail-Adresse',
      mobileNumber: 'Handynummer'
    },
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-4'
      }
    ]
  },
  {
    id: 'step-4',
    formComponent: 'FormOccupation',
    name: 'Occupation',
    title: 'Was machen Sie aktuell?',
    description: '',
    formData: {
      occupation: ''
    },
    formLabels: {
      occupation: 'Was machen Sie aktuell?'
    },
    formOptions: {
      occupation: [
        stepsConstants.i_am_employed,
        'Ich mache eine Ausbildung.',
        'Ich studiere.',
        'Ich bin selbstständig.',
        'Ich bekomme Arbeitslosengeld.',
        'Ich bekomme Bürgergeld.',
        'Ich bekomme eine Rente.',
        stepsConstants.i_do_something_else
      ]
    },
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-4-1',
        conditionFunc: function (values) {
          return values.occupation === stepsConstants.i_am_employed
        }
      },
      {
        id: 'step-4-2',
        conditionFunc: function (values) {
          return values.occupation === stepsConstants.i_do_something_else
        }
      },
      {
        id: 'step-5',
        conditionFunc: function (values) {
          return values.occupation !== stepsConstants.i_am_voluntary_insured && values.occupation !== stepsConstants.i_do_something_else
        }
      }
    ]
  },
  {
    id: 'step-4-1',
    formComponent: 'FormOccupationEmployed',
    name: 'OccupationEmployed',
    title: 'Sind Sie nebenbei selbstständig?',
    description: '',
    formData: {
      partTimeSelfEmployed: null
    },
    formLabels: {
      partTimeSelfEmployed: 'Sind Sie nebenbei selbstständig?'
    },
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-5'
      }
    ]
  },
  {
    id: 'step-4-2',
    formComponent: 'FormOccupationOther',
    name: 'OccupationOther',
    title: stepsConstants.i_do_something_else,
    description: '',
    formData: {
      occupationOther: '',
      workingAs: ''
    },
    formLabels: {
      occupationOther: stepsConstants.i_do_something_else,
      workingAs: '...und arbeite als'
    },
    formOptions: {
      occupationOther: [
        stepsConstants.i_am_voluntary_insured,
        'Vermieter',
        'Haushaltsmanager',
        'Schüler (Meister- oder Berufsfachschüler)'
      ]
    },
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-5'
      }
    ]
  },
  {
    id: 'step-5',
    formComponent: 'FormIncludeFamily',
    name: 'IncludeFamily',
    title: 'Ich möchte meine Familie kostenlos mitversichern. 👨‍👩‍👧‍👦',
    formData: {
      includeFamily: null
    },
    formLabels: {
      includeFamily: 'Ich möchte meine Familie kostenlos mitversichern.'
    },
    description: '',
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-6'
      }
    ]
  },
  {
    id: 'step-6',
    formComponent: 'FormDataPrivacy',
    name: 'DataPrivacy',
    title: 'Noch ein Schritt ...',
    description: 'Bitte stimmen Sie unserem Datenschutz zu.',
    formData: {
      generalAdvertisingAccepted: null
    },
    formLabels: {
      generalAdvertisingAccepted: 'Ich bin damit einverstanden, persönliche Angebote von der BKK GILDEMEISTER SEIDENSTICKER telefonisch oder per E-Mail zu erhalten. Diese Einwilligung kann ich jederzeit widerrufen.'
    },
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Weiter'
    },
    possibleNextSteps: [
      {
        id: 'step-7',
      }
    ]
  },
  {
    id: 'step-7',
    formComponent: 'FormSummary',
    name: 'Summary',
    title: 'Daten prüfen',
    description: 'Bitte überprüfen Sie Ihre Daten.',
    visible: false,
    controls: {
      previous: 'Zurück',
      next: 'Antrag absenden'
    },
    possibleNextSteps: [
      {
        id: 'step-8',
        doBeforeGoToNextStep: 'submit'
      }
    ],
    summary: true
  },
  {
    id: 'step-8',
    name: 'End',
    title: 'Super 👏',
    description: 'Vielen Dank für Ihre Anmeldung.',
    visible: false,
    controls: {
      previous: null,
      next: 'Zur BKKGS  Startseite'
    },
    isLast: true
  }
]
